/**
 * 32 random bytes encoded as hex (password-reset, email-verification/change
 * tokens). Generated tokens are always lowercase, so uppercase input is
 * rejected here rather than failing the later hash comparison.
 */
export const HEX_TOKEN_PATTERN = "^[a-f0-9]{64}$";

export const HEX_TOKEN_REGEX = new RegExp(HEX_TOKEN_PATTERN);
